import React, { useEffect, useState } from 'react';
import './PropertyRailNavigation.css';

const PropertyRailNavigation = ({ railRef, count, page }) => {
  const [position, setPosition] = useState({ index: 0, overflowing: false, atEnd: false });

  useEffect(() => {
    const rail = railRef.current;
    if (!rail) return undefined;
    let frame;
    const update = () => {
      const left = rail.getBoundingClientRect().left;
      const items = Array.from(rail.children);
      let index = 0;
      items.forEach((item, itemIndex) => {
        if (Math.abs(item.getBoundingClientRect().left - left) < Math.abs(items[index].getBoundingClientRect().left - left)) index = itemIndex;
      });
      setPosition({ index, overflowing: rail.scrollWidth > rail.clientWidth + 2, atEnd: rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2 });
    };
    const scheduleUpdate = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(update);
    };
    update();
    const observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(scheduleUpdate) : null;
    observer?.observe(rail);
    rail.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate);
    return () => {
      cancelAnimationFrame(frame);
      observer?.disconnect();
      rail.removeEventListener('scroll', scheduleUpdate);
      window.removeEventListener('resize', scheduleUpdate);
    };
  }, [railRef, count, page]);

  const move = direction => {
    const rail = railRef.current;
    const target = rail?.children[position.index + direction];
    if (!target) return;
    rail.scrollTo({
      left: rail.scrollLeft + target.getBoundingClientRect().left - rail.getBoundingClientRect().left,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
    });
  };

  if (!position.overflowing) return null;
  return (
    <div className="property-rail-navigation" role="group" aria-label="Browse property tiles">
      <div className="property-rail-navigation-copy">
        <strong>{position.atEnd ? 'Swipe to revisit homes' : 'Swipe to explore homes'} <span aria-hidden="true">{position.atEnd ? '←' : '→'}</span></strong>
        <span role="status" aria-live="polite">{position.index >= count ? 'More homes' : `Home ${position.index + 1} of ${count}`}</span>
      </div>
      <div className="property-rail-navigation-buttons">
        <button type="button" onClick={() => move(-1)} disabled={position.index === 0} aria-label="Previous property"><span aria-hidden="true">←</span></button>
        <button type="button" onClick={() => move(1)} disabled={position.atEnd} aria-label={position.index === count - 1 ? 'Show more homes' : 'Next property'}><span aria-hidden="true">→</span></button>
      </div>
    </div>
  );
};

export default PropertyRailNavigation;
